import React, { useState } from 'react'
import { GraviButton, Horizontal, Vertical } from '@gravitate-js/excalibrr'
import { CostingGrid } from './CostingGrid'
import { Details } from '@components/InventoryValuation/Costing/Details/Details'
import moment from 'moment/moment'
import '../inventory.css'

export function InventoryCosting() {
  const [headerData, setHeaderData] = useState({ site: null, product: null, isProjected: false })
  const [isFullWidth, setIsFullWidth] = useState(false)
  const [selectedICI, setSelectedICI] = useState(null)
  const [filters, setFilters] = useState({
    date: new Date(),
  })
  const [expandedRows, setExpandedRows] = useState([])

  return (
    <Horizontal style={{ padding: '1rem', gap: '1rem', height: '100%', width: '100%' }}>
      <Vertical flex={1} height={'100%'}>
        <CostingGrid
          isFullWidth={isFullWidth}
          setIsFullWidth={setIsFullWidth}
          date={filters.date}
          filters={filters}
          setFilters={setFilters}
          setHeaderData={setHeaderData}
          setSelectedICI={setSelectedICI}
        />
      </Vertical>
      {!isFullWidth && (
        <Vertical flex={1}>
          <Details
            filterDate={filters.date}
            selectedICI={selectedICI}
            headerData={headerData}
            setExpandedRows={setExpandedRows}
            expandedRows={expandedRows}
          />
        </Vertical>
      )}
    </Horizontal>
  )
}
